import React from 'react';
import { useTranslation } from 'react-i18next';

function HeaderCourse() {
  const { t } = useTranslation();
  return (
    <div className="col-lg-12 p-0">
      <div className="iq-card">
        <div className="iq-card-body p-0">
          <div className="user-tabing p-3">
            <div className="d-flex align-items-center justify-content-between row">
              <div className="col-lg-12">
                <ul
                  className="nav nav-pills nav-fill"
                  id="pills-tab-1"
                  role="tablist"
                >
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      data-toggle="pill"
                      href="#courses"
                    >
                      <b>{t("kursus")}</b>
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-toggle="pill"
                      href="#mycourses"
                    >
                      <b>{t("kursus_saya")}</b>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeaderCourse;
